import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import ReimbursementProduct from 'core/domain/benefit/reimbursementProduct'

import { Button, Col, Modal, Row } from '../common/components'
import Radio from '../common/components/dataEntry/formik/FormikRadioField'
import Alert from '../common/components/feedback/Alert'
import Icon from '../common/components/general/Icon'

type SelectReimbursementProductModalProps = {
  isSelectReimbursementProductModalOpen: boolean
  onSubmit: (reimbursementProduct: number) => void
  onCancel: () => void
}

type FormInitialValues = {
  reimbursementProduct: number
}

type PlansType = {
  planType: number
  title: string
  description: string
}

const SelectReimbursementProductModal = ({
  isSelectReimbursementProductModalOpen,
  onSubmit,
  onCancel,
}: SelectReimbursementProductModalProps) => {
  const [initialValues] = useState<FormInitialValues>({
    reimbursementProduct: 2,
  })
  const { t: translate } = useTranslation()

  const plans: PlansType[] = [
    {
      planType: ReimbursementProduct.PremiumPlusOutOfPocketExpenses,
      title: translate(
        'admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.premium-plus-out-of-pocket-expenses-title',
      ),
      description: translate(
        'admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.premium-plus-out-of-pocket-expenses-description',
      ),
    },
    {
      planType: ReimbursementProduct.PremiumsOnly,
      title: translate('admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.premium-only-title'),
      description: translate(
        'admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.premium-only-description',
      ),
    },
  ]

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={initialValues}
      onSubmit={() => {}}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        return {}
      }}
      validateOnChange={true}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        // bindSubmitFormHandler(submitForm)
        return (
          <Modal
            visible={isSelectReimbursementProductModalOpen}
            okText={'Save'}
            onOk={() => onSubmit(formik.values.reimbursementProduct)}
            onCancel={() => onCancel()}
            closable
          >
            <form autoComplete="off" onSubmit={handleSubmit} className="select_class">
              <Row className="mt-24">
                <Col span={24}>
                  <h5 className="select_class_info mb-8">
                    {translate('admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.header')}
                  </h5>
                </Col>
              </Row>
              <Alert
                message={translate('admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.alert')}
                type="info"
                showIcon
                icon={<Icon className="far fa-info-circle" />}
                className="mb-24"
              />

              <Radio.Group
                name="reimbursementProduct"
                className="qsehra-reimbursement-plan-option"
                defaultValue={formik.values['reimbursementProduct']}
              >
                {plans.map((item) => (
                  <Radio.Button
                    key={item.planType}
                    value={item.planType}
                    contentAlign="start"
                    size="small"
                    className="mb-16"
                  >
                    <div>
                      <Row>
                        <Col span={24}>
                          <h5 className="mb-8">{item.title}</h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <p className="color-gray-7">{item.description}</p>
                        </Col>
                      </Row>
                    </div>
                  </Radio.Button>
                ))}
              </Radio.Group>
            </form>
          </Modal>
        )
      }}
    </Formik>
  )
}

export default SelectReimbursementProductModal

const formValidator = (translate: any) =>
  Yup.object({
    reimbursementProduct: Yup.number().required(
      translate('admin-dashboard.benefit-details.class-design.qsehra.reimburse-product.error'),
    ),
  })
